import { withInstall } from '@antdv/utils';
import AAffix from './src/Affix';

export const Affix = withInstall(AAffix);

export * from './src/interface';
export * from './src/props';

export default Affix;
